import React, { Component } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { render } from "react-dom";
import { object } from "prop-types";
import classNames from "classnames";
import axios from "axios";
import config from "../../config";
// import { runQuery, createQueryCTA } from '../../utils/KeenReport'

// utils
// import numeral from "../../utils/numeral";
// import { toHHMMSS } from "../../utils/util";

// components
// import Spinner from "../Spinner";
// import MarksTable from "./MarksTable";

// c3
import C3Chart from "react-c3js";
import "c3/c3.css";

class BarFunnel extends Component {
  constructor(props) {
    super(props);

    let uniqueId = "barFunnel" + this.props.video.id;

    this.state = {
      isLoading: false,
      hasError: false,
      isEmpty: false,
      uniqueId: uniqueId,
      progressBarValue: 0,
      done: false
    };

    this.mountAndPlot = this.mountAndPlot.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.startProgressBar = this.startProgressBar.bind(this);
  }
  startProgressBar() {
    var self = this;
    const counter = setInterval(function() {
      if (self.state.progressBarValue === 95) {
        clearInterval(counter);
      } else {
        self.setState({
          progressBarValue: self.state.progressBarValue + 1
        });
      }
    }, 1200);
  }
  componentDidMount() {
    // this.mountAndPlot(this.props)
  }
  componentWillReceiveProps(nextProps) {
    // this.mountAndPlot(nextProps)
  }
  handleClick() {
    this.mountAndPlot(this.props);
  }
  mountAndPlot(props) {
    let { video } = props;
    this.setState({
      isLoading: true,
      hasError: false,
      isEmpty: false,
      progressBarValue: 0,
      done: false
    });
    this.startProgressBar();
    let url = `${config.trackingReportUrl}/videos/${video.id}/bar_funnel`;

    axios({
      method: "POST",
      // headers: { "X-User-Token": getAuthToken() },
      headers: { Accept: "application/json; charset=utf-8" },
      url: url,
      data: {
        start_date: this.props.timeframe.start,
        end_date: this.props.timeframe.end
      }
    })
      .then(res => {
        let funnelDataArray = res.data;
        let funnelData = funnelDataArray.reduce(
          (total, currentValue) => {
            total["cliques"] += currentValue["cliques"];
            total["visitas"] += currentValue["visitas"];
            total["plays"] += currentValue["plays"];
            return total;
          },
          { cliques: 0, visitas: 0, plays: 0 }
        );
        const data = {
          columns: [["Sessões", funnelData.cliques, funnelData.visitas, funnelData.plays]],
          type: "bar",
          labels: true
        };
        const axis = {
          x: {
            type: "category",
            categories: ["Cliques", "Visitas", "Plays"]
          }
        };
        const mountNode = document.getElementById(this.state.uniqueId);
        const chart = <C3Chart data={data} axis={axis} />;
        render(chart, mountNode);
        this.setState({
          isLoading: false,
          hasError: false,
          isEmpty: false,
          progressBarValue: 100,
          done: true
        });
      })
      .catch(err => {
        console.log("Deu erro!", err);
        this.setState({
          isLoading: false,
          hasError: false,
          isEmpty: true
        });
      });
  }
  render() {
    let { uniqueId, isLoading, hasError, isEmpty, progressBarValue, done } = this.state;
    return (
      <div>
        <p style={done ? { display: "none" } : { textAlign: "center" }}>
          O carregamento do funil pode demorar até 2 minutos. Clique abaixo para começar.
        </p>
        <div style={isLoading ? {} : { display: "none" }}>
          <ProgressBar now={progressBarValue} label={`${progressBarValue}%`} />
        </div>
        <div className={classNames({ hidden: isLoading || isEmpty })}>
          <div id={uniqueId} />
        </div>
        <div style={done ? { display: "none" } : { textAlign: "center" }}>
          <Button bsStyle="primary" disabled={isLoading} onClick={!isLoading ? this.handleClick : null}>
            {isLoading ? "Carregando..." : "Carregar Funil"}
          </Button>
        </div>
      </div>
    );
  }
}

BarFunnel.propTypes = {
  timeframe: object,
  campaign: object,
  take: object
};

export default BarFunnel;



// WEBPACK FOOTER //
// ./src/components/charts/BarFunnel.js